<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :show-close="true"
    :before-close="beforeClose"
    :modal-append-to-body="false"
    width="750px"
    :title="
      $t('Audiences_SegmentEvaluations_RollingSync_DialogTitle', {
        date: dateCreated
      })
    "
    center
  >
    <segment-counts-top-bar
      :metrics="taskData.task.results"
      type="rolling"
      :columns="3"
    />
  </el-dialog>
</template>

<script>
import SegmentCountsTopBar from '@/modules/audiences/components/SegmentCountsTopBar.vue'
import { EventBus } from '@/core/EventBus'
import moment from 'moment/moment'

export default {
  name: 'RollingSyncPreviewDialog',
  components: { SegmentCountsTopBar },
  props: {
    taskData: {
      type: Object,
      required: true
    }
  },
  methods: {
    beforeClose() {
      EventBus.$emit('close-rolling-sync-preview-dialog')
    }
  },
  computed: {
    dateCreated() {
      return this.taskData
        ? moment(this.taskData.create_time * 1000).format('DD-MMM-YYYY HH:mm')
        : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/RollingSyncPreviewDialog.vue